"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Initializer = void 0;
/** @deprecated please use InitializerV2 instead */
class Initializer {
    constructor(dependencies = []) {
        this.dependencies = [];
        this.isInitialized = false;
        this.getInitialized = () => {
            if (!this.initialized) {
                throw new Error();
            }
            return this.initialized;
        };
        this.setInitialized = (_initialized) => {
            this.isInitialized = true;
            this.initialized = _initialized;
        };
        this.dependencies = dependencies;
    }
}
exports.Initializer = Initializer;
//# sourceMappingURL=initializer.js.map